import { Box, styled } from '@mui/material';
import { ultraMarine } from '../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginLeft: 'auto',
  flexShrink: 0,
  '& .openButton': {
    border: 0,
    outline: 0,
    cursor: 'pointer',
    font: 'inherit',
    textTransform: 'none',
    fontWeight: 700,
    lineHeight: 1,
    padding: '8px 16px',
    borderRadius: 8,
    backgroundColor: ultraMarine[600],
    color: 'white',
    '&:hover': {
      backgroundColor: ultraMarine[700],
    },
  },
  '& .closeButton': {
    border: 0,
    outline: 0,
    cursor: 'pointer',
    background: 'transparent',
    width: 28,
    height: 28,
    padding: 0,
    color: ultraMarine[600],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default StyledBox;
